import { ReactNode } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styled, { css } from 'styled-components';

// Bryts till fler rader när flikarna inte ryms. Inställningssidans tolv flikar var ~1700 px och
// gav hela sidan sidscroll på en laptop.
export const MenuContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: baseline;
  margin: 10px 10px;
  gap: 8px 30px;
`;

export const MenuItem = styled.button<{ selected?: boolean }>`
  padding-bottom: 1px;
  border: none;
  border-bottom: 2px solid transparent;
  background-color: transparent;
  color: ${({ theme }) => theme.colors.foreground.primary};
  font: inherit;
  text-transform: capitalize;
  white-space: nowrap;
  cursor: pointer;

  ${({ selected, theme }) =>
    selected &&
    css`
      padding-bottom: 1px;
      border-bottom: 2px solid ${theme.colors.foreground.tint};
      font-weight: bold;
    `}

  &:hover {
    color: ${({ theme, selected }) =>
      selected
        ? theme.colors.foreground.primary
        : theme.colors.foreground.tint};
  }
`;

export const SubMenuTitle = styled.h1`
  flex: 1;
  font-size: ${({ theme }) => theme.sizes.font.medium};
  font-weight: 500;
`;

export interface IMenuItem {
  label: ReactNode;
  path: string;
  /** Markera fliken även på adresser under den, för en flik som har egna underflikar. */
  matchPrefix?: boolean;
}

export const isSelected = (pathname: string, item: IMenuItem) =>
  pathname === item.path ||
  (!!item.matchPrefix && pathname.startsWith(`${item.path}/`));

type Props = {
  items: IMenuItem[];
};
const SubMenu: React.FC<Props> = ({ items }) => {
  const location = useLocation();
  const navigate = useNavigate();
  return (
    <MenuContainer>
      {items.map((i) => (
        <MenuItem
          key={i.path}
          onClick={() => {
            navigate(i.path);
          }}
          selected={isSelected(location.pathname, i)}
        >
          {i.label}
        </MenuItem>
      ))}
    </MenuContainer>
  );
};

export default SubMenu;
